export default __webpack_public_path__ + "static/media/4.ae51a4b2.png";